import { createFileRoute } from '@tanstack/react-router';
import { RunDetailPage } from '@/features/settings/AgentsPages';

export const Route = createFileRoute('/app/settings/agents/runs/$runId')({
  component: function RunRoute() {
    const { runId } = Route.useParams();
    return <RunDetailPage key={runId} runId={runId} />;
  },
  staticData: { title: 'Agent run · Settings' },
});
